/**
 * en-GB messages added by Phase 1 task S7 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s7EnGB = {
    'nav.devices': 'Devices',
    'nav.devices.desc': 'Kiosks and printers, health and alerts',
    // Fault emails (spec 8.2). Params: {device}, {site}, {problem}, {since}, {tenant}, link.
    'email.kiosk-devices.alert.subject': 'Needs attention: {device} at {site}',
    'email.kiosk-devices.alert.body': '{device} at {site} has a problem: {problem}. Since {since}.',
    'email.kiosk-devices.alert.button': 'Open the device page',
    'email.kiosk-devices.alert_cleared.subject': 'Back to normal: {device} at {site}',
    'email.kiosk-devices.alert_cleared.body': '{device} at {site} is back to normal. It had a problem: {problem} (since {since}).',
    'email.kiosk-devices.alert_cleared.button': 'Open the device page',
    // Problem text inside the email (with details), and the short name of each fault.
    'kioskDevices.alert.problem.offline': 'It has not reported for {minutes} minutes',
    'kioskDevices.alert.problem.battery_low': 'The battery is low ({batteryPercent}%)',
    'kioskDevices.alert.problem.not_charging': 'It has not been charging for {minutes} minutes',
    'kioskDevices.alert.problem.printer_fault': 'The printer needs attention ({state})',
    'kioskDevices.alert.problem.labels_low': 'The printer is running out of labels ({labelsLeft} left)',
    'kioskDevices.alert.problem.app_outdated': 'The kiosk app is out of date',
    'kioskDevices.alert.name.offline': 'Offline',
    'kioskDevices.alert.name.battery_low': 'Low battery',
    'kioskDevices.alert.name.not_charging': 'Not charging',
    'kioskDevices.alert.name.printer_fault': 'Printer problem',
    'kioskDevices.alert.name.labels_low': 'Labels running low',
    'kioskDevices.alert.name.app_outdated': 'App out of date',
    // Site and platform settings of this module (the tenant ones are labelled in w5.ts).
    'settings.kiosk-devices.alertEmail': 'Send fault emails to',
    'settings.kiosk-devices.alertsEnabled': 'Send fault emails for this site',
    'settings.kiosk-devices.latestAppVersion': 'Latest app version',
    'settings.kiosk-devices.latestBundleVersion': 'Latest screens version',
};
//# sourceMappingURL=s7.js.map